import $ from "jquery";

export default function onWindowLoad() {
    window.onload = function () {

        //======================================================================================================
        //Klick auf Hauptprodukt führt zur der Seite des Produktes
        //======================================================================================================
        $("#menu-hauptmenu .nav-link").removeAttr("data-bs-toggle");
        $(".dropdown-item.dropdown-toggle").removeAttr("data-bs-toggle");
        //======================================================================================================
        //Swiper and Sticky Elements
        //======================================================================================================
        if(window.innerWidth > 992) {
            //$(".swiper-buttons-container").before($(".theme-parent-pagination"));
            $(".review-module").attr("aria-hidden","false");
            $(".menu-mobile").attr("aria-hidden","true");
            $(".menu-desktop").attr("aria-hidden","false");
            $(".sticky-element-termin-desktop").attr("aria-hidden","false");
            $(".sticky-element-termin-mobile").attr("aria-hidden","true");
        }
        else {
            $(".review-module").attr("aria-hidden","true");
            $(".menu-mobile").attr("aria-hidden","false");
            $(".menu-desktop").attr("aria-hidden","true");
            $(".sticky-element-termin-desktop").attr("aria-hidden","true");
            $(".sticky-element-termin-mobile").attr("aria-hidden","false");
            $( ".swiper-container-mobile" ).append( $( ".reviews.reviews-swiper.swiper" ));
            $( ".swiper-container-pagination-mobile" ).append( $( ".reviews-pagination-buttons" ));
            /*if ($(".reviews-pagination-elements > .swiper-pagination").length == 0) {
                $( ".reviews-pagination-elements").append( $( ".swiper-pagination" ));
                $( ".swiper-button-next-review").before( $( ".swiper-pagination" ));
            }*/
            if ($(".review-module-title-mobile > .review-module-title-content").length == 0) {
                $(".review-module-title-mobile").append($(".review-module-title-content"));
            }
            //$(".menu-item-has-children > .nav-link > .post-title").addClass("add-after");
        }
        //======================================================================================================
        // Projekt Referenz wird als Swipe in der Mobile Ansicht angezeit
        //======================================================================================================
        if($(".gallery-photo-viewer").length > 0) {

            let imageActive = $(".gallery-swiper >.swiper-wrapper > .swiper-slide:first-child .image-swiper-slide");
            imageActive.prev().addClass("show-bar");
            let imageElement = document.createElement("img");
            imageElement.setAttribute("src", imageActive.attr("src"));
            imageElement.setAttribute("alt", imageActive.attr("alt"));
            imageElement.setAttribute("class", "view-image");
            $(".gallery-photo-viewer").append(imageElement);
            $(".gallery-photo-viewer img").css("opacity","1");
        }
        if($(".reviews").length > 0) {
            let reviewActive = $(".reviews-list#1").clone();
            $(".review-viewer").append(reviewActive);
        }

        //======================================================================================================
        // Erste Frage des FAQs Bereich muss geöffnet sein
        //======================================================================================================
        if ($(".faq-questions").length > 0) {
            $(".faq-questions > .faq-question-reply:first-of-type > button").addClass("current");
            $(".faq-questions > .faq-question-reply:first-of-type > button").addClass("question-active");
            $(".faq-questions > .faq-question-reply:first-of-type > .faq-reply").addClass("question-show");
        }
        if ($(".faq-overlapping-text").length > 0) {
            $(".faq-overlapping-text > .faq-question-reply:first-of-type > button").addClass("current");
            $(".faq-overlapping-text > .faq-question-reply:first-of-type > button").addClass("question-active");
            $(".faq-overlapping-text > .faq-question-reply:first-of-type > .faq-reply").addClass("question-show");
        }
        $(".theme-parent-pagination").addClass("animate");
        $(".swiper-buttons-container").addClass("animate");
        setTimeout(function() {
            $(".theme-parent-pagination").removeClass("animate");
            $(".swiper-buttons-container").removeClass("animate");
        }, 200);

    }

}
